import React, { useMemo } from 'react';
import styles from '../../assets/styles/MimaCheckout/MimaCheckout.module.scss';
import {
	MimaButton,
	MimaText,
	MimaToastUtil,
	PageLoader,
} from '../../components';
import validateImg from '../../assets/img/Mimaweb.png';
import { MdOutlineContentCopy } from 'react-icons/md';
import { invoiceStore } from '../../stores';
import { amountFormatter } from '../../utils/utils';
import AUDLogo from '../../assets/img/AUD logo.png';
import USDLogo from '../../assets/img/USD logo.png';
import EURLogo from '../../assets/img/EUR logo.png';
import SGDLogo from '../../assets/img/SGD logo.png';
import CADLogo from '../../assets/img/CAD logo.png';
import GBPLogo from '../../assets/img/GBP logo.svg';
import { FaInfoCircle } from 'react-icons/fa';
import { mimaPayLogo } from '../../assets';

const FxTransfer = ({
	validatePaymentClick,
	validatePay,
	chooseCurr,
	setChooseCurr,
	loading,
	switchPaymentDetails,
	loading3,
	loading2,
}) => {
	const fxDetails = invoiceStore?.fxTransferCheckoutData;
	const fxAccount = invoiceStore?.fxTransferCheckoutData?.foreignAccount || {};
	const currencies = useMemo(() => {
		return [
			{
				currencyCode: 'AUD',
				logo: AUDLogo,
				country: 'Australia',
			},
			{
				currencyCode: 'CAD',
				logo: CADLogo,
				country: 'Canada',
			},
			{
				currencyCode: 'EUR',
				logo: EURLogo,
				country: 'Europe',
			},
			{
				currencyCode: 'GBP',
				logo: GBPLogo,
				country: 'United Kingdom',
			},
			{
				currencyCode: 'SGD',
				logo: SGDLogo,
				country: 'Singapore',
			},
			{
				currencyCode: 'USD',
				logo: USDLogo,
				country: 'USA',
			},
		];
	}, []);

	const currShowing = useMemo(() => {
		return currencies?.filter(x => x.currencyCode === chooseCurr)[0] || {};
	}, [chooseCurr, currencies]);

	return (
		<>
			{loading ? (
				<PageLoader title="while we load your checkout Info" />
			) : (
				<div className={styles.main}>
					<div className={styles.bizInfo}>
						<img src={mimaPayLogo} alt="Mima Logo" />

						<div>
							<MimaText variant="bodyBold">
								{fxDetails?.business?.tradingName}
							</MimaText>
							<MimaText color="var(--color-green)">
								{validatePay ? 'Validating Payment for' : 'Pay'}{' '}
								{/* {amountFormatter(fxDetails?.currencyCode).format(
									fxDetails?.deposit + (fxDetails?.customerProcessingFee || 0)
								)}	 */}
								{amountFormatter(fxAccount?.currencyCode).format(
									fxAccount?.expectedAmount
								)}
							</MimaText>
						</div>
					</div>

					{validatePay ? (
						<div className={styles.payInfo}>
							<img
								src={validateImg}
								alt="Validating"
								className={styles.successImg}
							/>
							<MimaText
								variant="h3"
								align="center"
								mb={1}
								mt={2}
								color="var(--color-primary)">
								Payment In Validation
							</MimaText>
							<MimaText variant="subtitleBold" align="center" width={40}>
								You will get an update on this transfer transaction in 15 - 30
								30
							</MimaText>
						</div>
					) : (
						<>
							<div className={styles.payInfo}>
								<MimaText align="center" variant="subtitleBold">
									Pay{' '}
									<span className={styles.span}>
										{amountFormatter(fxAccount?.currencyCode).format(
											fxAccount?.expectedAmount
										)}
									</span>{' '}
									by bank transfer
								</MimaText>
								<MimaText align="center" mb={2} variant="small">
									The details to use depend on where your bank account’s
									registered.
								</MimaText>
								<div className={styles.payInfo__info}>
									<FaInfoCircle />{' '}
									<p>
										When paying through your bank, make sure to use the
										reference{' '}
										<span
											style={{
												fontWeight: 700,
											}}
											onClick={() => {
												navigator.clipboard.writeText(fxAccount?.code);
												MimaToastUtil.success({
													message: `Reference Copied!`,
												});
											}}>
											{fxAccount?.code}
										</span>
										.
									</p>
								</div>
								<div className={styles.payInfo__main}>
									<div className={styles.payInfo__nav}>
										<MimaText variant="smallBold">PAY IN</MimaText>
										{currencies.map((x, i) => (
											<div
												className={`${styles.payInfo__nav_item} ${chooseCurr === x.currencyCode ? styles.payInfo__nav_active : ''}`}
												onClick={() => {
													setChooseCurr(x.currencyCode);
													switchPaymentDetails(x.currencyCode);
												}}
												key={i}>
												<img src={x.logo} alt="Currency" />

												{x.currencyCode}
											</div>
										))}
									</div>
									<div className={styles.payInfo__main_text2}>
										{loading3 ? (
											<PageLoader type="bar" />
										) : (
											<>
												<div className={styles.payInfo__info2}>
													<img src={currShowing?.logo} alt="Currency" />{' '}
													<p>
														{' '}
														Use these details to pay {
															currShowing?.currencyCode
														}{' '}
														from bank accounts inside {currShowing?.country}
													</p>
												</div>
												<div className={styles.payInfo__main_text2__grid}>
													<MimaText labelTitle="Reference" variant="small">
														{fxAccount?.code}
													</MimaText>
													<MdOutlineContentCopy
														onClick={() => {
															navigator.clipboard.writeText(fxAccount?.code);
															MimaToastUtil.success({
																message: `Transfer Code Copied!`,
															});
														}}
													/>
												</div>

												{fxAccount?.id?.metadata?.data?.map((details, i) => (
													<div
														key={i}
														className={styles.payInfo__main_text2__grid}>
														<MimaText
															labelTitle={details?.label}
															// variant="h3"
															// align="center"
															// style={{ display: 'flex' }}
															variant="small">
															{details?.value}{' '}
														</MimaText>
														<MdOutlineContentCopy
															onClick={() => {
																navigator.clipboard.writeText(details?.value);
																MimaToastUtil.success({
																	message: `${details?.label} Copied!`,
																});
															}}
														/>
													</div>
												))}
											</>
										)}
									</div>
								</div>

								<MimaButton
									buttonColor="var(--color-dark)"
									title="Validate Payment"
									mt={2}
									onClick={validatePaymentClick}
									loading={loading2}
								/>
							</div>
						</>
					)}

					<MimaText align="center" mt={7}>
						Powered by Mima pay
						<br />
						Visit{' '}
						<a
							className={styles.a}
							href="https://app.mimapay.com/signup"
							target="_blank"
							rel="noreferrer">
							app.mimapay.africa/signup
						</a>{' '}
						to get started
					</MimaText>
				</div>
			)}
		</>
	);
};

export default FxTransfer;
